import React from 'react';
import { FaTimes, FaPills } from 'react-icons/fa';

const MedicineCartItem = ({
  item,
  onRemove,
  onUpdateMRP,
  onUpdateAyushPayPrice,
  onUpdateQuantity,
  onToggleOutOfStock
}) => {
  return (
    <div className={`bg-gray-50 rounded-lg p-4 border ${item.outOfStock ? 'border-red-300 bg-red-50' : 'border-gray-200'}`}>
      <div className="flex items-start gap-4 mb-3">
        {/* Medicine Image/Icon */}
        <div className="flex-shrink-0 w-20 h-20 bg-white rounded-lg border border-gray-200 flex items-center justify-center overflow-hidden relative">
          {item.image ? (
            <>
              <img 
                src={item.image} 
                alt={item.name}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  const iconDiv = e.target.parentElement.querySelector('.medicine-icon');
                  if (iconDiv) iconDiv.style.display = 'flex';
                }}
              />
              <div className="medicine-icon w-full h-full flex items-center justify-center absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50" style={{ display: 'none' }}>
                <FaPills className="w-12 h-12 text-blue-400" />
              </div>
            </>
          ) : (
            <div className="medicine-icon w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
              <FaPills className="w-12 h-12 text-blue-400" />
            </div>
          )}
        </div>
        {/* Medicine Name and Remove Button */}
        <div className="flex-1 flex items-start justify-between">
          <div>
            <h4 className={`font-medium ${item.outOfStock ? 'text-red-600 line-through' : 'text-gray-900'}`}>
              {item.name}
            </h4>
            {item.packSize && (
              <p className="text-xs text-gray-600 mt-1">{item.packSize}</p>
            )}
          </div>
          <button
            onClick={() => onRemove(item.itemId || item.medicineId)}
            className="text-red-500 hover:text-red-700 transition-colors ml-4"
          >
            <FaTimes className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex items-center justify-between gap-4 mb-3">
        <div className="flex items-center gap-4 flex-1">
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-gray-700">MRP (₹): <span className="text-red-500">*</span></label>
            <div className="flex flex-col">
              <input
                type="number"
                value={item.mrp === null || item.mrp === undefined ? '' : item.mrp}
                onChange={(e) => onUpdateMRP(item.itemId || item.medicineId, e.target.value)}
                onKeyDown={(e) => {
                  // Prevent arrow keys from changing the value
                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => {
                  // Prevent scroll from changing the value
                  e.target.blur();
                }}
                step="0.01"
                min="0"
                className={`w-24 px-3 py-1.5 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                  item.mrpError ? 'border-red-500' : 'border-gray-300'
                }`}
              />
              {item.mrpError && (
                <span className="text-xs text-red-600 mt-0.5">{item.mrpError}</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-gray-700">AyushPay Price (₹): <span className="text-red-500">*</span></label>
            <div className="flex flex-col">
              <input
                type="number"
                value={item.ayushpayPrice === null || item.ayushpayPrice === undefined ? '' : item.ayushpayPrice}
                onChange={(e) => onUpdateAyushPayPrice(item.itemId || item.medicineId, e.target.value)}
                onKeyDown={(e) => {
                  // Prevent arrow keys from changing the value
                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => {
                  // Prevent scroll from changing the value
                  e.target.blur();
                }}
                step="0.01"
                min="0"
                className={`w-24 px-3 py-1.5 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                  item.ayushpayPriceError ? 'border-red-500' : 'border-gray-300'
                }`}
              />
              {item.ayushpayPriceError && (
                <span className="text-xs text-red-600 mt-0.5">{item.ayushpayPriceError}</span>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">Quantity:</label>
          <button
            onClick={() => onUpdateQuantity(item.itemId || item.medicineId, -1)}
            className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-md hover:bg-gray-100 transition-colors"
          >
            -
          </button>
          <span className="w-12 text-center font-medium text-gray-900">{item.quantity}</span>
          <button
            onClick={() => onUpdateQuantity(item.itemId || item.medicineId, 1)}
            className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-md hover:bg-gray-100 transition-colors"
          >
            +
          </button>
        </div>
      </div>
      {/* Out of Stock Checkbox */}
      <div className="pt-3 border-t border-gray-200">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={item.outOfStock || false}
            onChange={() => onToggleOutOfStock(item.itemId || item.medicineId)}
            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <span className="text-sm font-medium text-gray-700">Mark as out of stock</span>
        </label>
      </div>
    </div>
  );
};

export default MedicineCartItem;

